import { useEffect } from "react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Faq from "@/components/sections/Faq";
import { Reveal } from "@/components/site/motion";

const FaqsPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div data-testid="faqs-page" className="bg-sand min-h-screen">
      <Navbar />
      <section className="pt-40 md:pt-48 pb-4">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <Reveal>
            <p className="text-sm uppercase tracking-[0.25em] text-terracotta mb-4">Support</p>
            <h1 className="font-serif text-5xl md:text-7xl text-forest tracking-tight leading-[0.98]">Frequently Asked Questions</h1>
            <p className="mt-6 text-lg text-ink2 max-w-2xl leading-relaxed">
              Everything you need to know about admission, our inpatient program, therapies and coverage — answered honestly and without judgement.
            </p>
          </Reveal>
        </div>
      </section>
      <Faq />
      <Footer />
    </div>
  );
};

export default FaqsPage;
